import { useState, useCallback, useEffect } from "react";
import { useUrlSyncedState } from "./useUrlSyncedState";

export function usePagination() {
  const { getParam, updateParams } = useUrlSyncedState();

  const [page, setPage] = useState(() => {
    const pageParam = getParam("page");
    return pageParam ? Math.max(0, Number(pageParam) - 1) : 0;
  });

  const [pageSize, setPageSize] = useState(() => {
    const limitParam = getParam("limit");
    return limitParam ? Number(limitParam) : 100;
  });

  const calculateTotalPages = useCallback(
    (totalItems: number) => {
      return Math.ceil(totalItems / pageSize);
    },
    [pageSize]
  );

  useEffect(() => {
    updateParams({
      page: String(page + 1),
      limit: String(pageSize),
    });
  }, [page, pageSize, updateParams]);

  const goToPage = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const changePageSize = useCallback(
    (newPageSize: number) => {
      if (page === 0) {
        setPageSize(newPageSize);
      } else {
        setPageSize(newPageSize);
        setPage(0);
      }
    },
    [page]
  );

  return {
    pagination: {
      page,
      pageSize,
      calculateTotalPages,
    },
    paginationActions: {
      goToPage,
      changePageSize,
    },
  };
}
